module.exports = __webpack_public_path__ + "static/img/kjfw_4.de4add3c.png";